module.exports = __webpack_public_path__ + "static/media/medical_title_white.618d6274.png";